import React, {useRef} from 'react'
import ApiService from "@bodeboca/api"
import {SearchBox} from "react-instantsearch"
import ResetSearch from "@bodeboca/algolia/components/search/search-reset"
import {useTranslation} from "react-i18next"
import CommonUtils from "@bodeboca/utils"

const CustomSearch = () => {
  const {t} = useTranslation()
  let timerId = useRef<any>(undefined)

  function debounceHook(query, search) {
    if (timerId.current) {
      clearTimeout(timerId.current)
    }
    if (query.length !== 0 && query.length > 2) {
      timerId.current = setTimeout(() => {
        search(query)
      }, CommonUtils.searchDebouceTmeout)
    }
  }

  return (<>
    <div
      className={ApiService.isBlockActive("search") ? "bodeboca-search-box-wrapper" : "hidden"}>
      <div id="bodeboca-search-box">
        <SearchBox
          classNames={{
            root: "MyCustomSearchBox",
            input: "bb-search-autocomplete-box form-text",
            loadingIcon: "bb-search-autocomplete-box-after icon bbicon-search",
            submitIcon: "bb-search-autocomplete-box-after icon bbicon-search",
          }}
          placeholder={t("Search for wine, winery, variety...")}
          queryHook={debounceHook}
          resetIconComponent={() => <ResetSearch/>}/>
      </div>
    </div>
  </>)
}
export default CustomSearch
